import { h, Component } from 'preact';
import { route } from 'preact-router';
import Loading from './../loader/Loading';
import style from './style';



class PageSelector extends Component {

    constructor() {
        super();
        this.state = { pages: {}, isNotFound: false };
        this._onClickCard = this._onClickCard.bind(this);
    }
    _onClickCard(e) {
        let pageId = e.currentTarget.dataset['id'];
        route('/' + pageId);
    }
    componentDidMount() {
        fetch(`https://shoutout-mlp.firebaseio.com/pages.json`)
            .then(r => r.json())
            .then(json => {
                this.setState({ pages: json });
            }).catch(e => {
                console.error(e);
                this.setState({ isNotFound: true });
            });
    }
    render() {
        const { pages } = this.state;
        const keys = Object.keys(pages);
        return (
            <div class={style.pageContainer}>
                {keys.length > 0 ? keys.map((pageId) => {
                    let page = pages[pageId];
                    return (
                        <div key={pageId} class={style.card} data-id={pageId} onClick={this._onClickCard}>
                            <h3>{page.name}</h3>
                            <p>{page.description}</p>
                        </div>
                    )
                }) :
                    <Loading isNotFound={this.state.isNotFound} />
                }
            </div>);

    }

}

export default PageSelector;


// WEBPACK FOOTER //
// ./components/pages/PageSelector.js